// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appointment-show {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-height: 100%;
}

.appointment-show__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 20px 32px;
  border-bottom: 1px solid #E2E8F0;
  background: #ffffff;
}

.appointment-show__header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
}

.appointment-show__back {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #64748B;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.12s ease, color 0.12s ease;
}

.appointment-show__back:hover {
  background: #F8FAFC;
  color: #0F172A;
}

[dir='rtl'] .appointment-show__back .anticon {
  transform: scaleX(-1);
}

.appointment-show__title-block {
  min-width: 0;
}

.appointment-show__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.appointment-show__title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.015em;
  line-height: 1.2;
  color: #0F172A;
}

.appointment-show__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid transparent;
  white-space: nowrap;
}

.appointment-show__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: currentColor;
  flex-shrink: 0;
}

.appointment-show__status.is-waiting {
  background: #FFFBEB;
  color: #B45309;
  border-color: #FED7AA;
}

.appointment-show__status.is-confirmed {
  background: #ECFDF5;
  color: #059669;
  border-color: #A7F3D0;
}

.appointment-show__status.is-invisit {
  background: #EFF6FF;
  color: #0284C7;
  border-color: #BFDBFE;
}

.appointment-show__status.is-finished {
  background: #F1F5F9;
  color: #475569;
  border-color: #E2E8F0;
}

.appointment-show__status.is-cancelled {
  background: #FEF2F2;
  color: #DC2626;
  border-color: #FECACA;
}

.appointment-show__status.is-pending,
.appointment-show__status.is-unreached,
.appointment-show__status.is-afterwork,
.appointment-show__status.is-postponed {
  background: #F8FAFC;
  color: #64748B;
  border-color: #E2E8F0;
}

.appointment-show__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.appointment-show__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.appointment-show__btn--secondary {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #0F172A;
}

.appointment-show__btn--secondary:hover {
  background: #F8FAFC;
}

.appointment-show__btn--secondary .anticon {
  color: #64748B;
  font-size: 14px;
}

.appointment-show__btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
}

.appointment-show__btn--primary:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.appointment-show__btn--finish {
  border: 1px solid #10B981;
  background: #ECFDF5;
  color: #059669;
}

.appointment-show__btn--finish:hover {
  background: #D1FAE5;
}

.appointment-show__btn--finish .anticon {
  font-size: 16px;
}

.appointment-show__body {
  flex: 1;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow: auto;
}

.appointment-show__section {
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: #ffffff;
  padding: 24px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.appointment-show__section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding-bottom: 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid #F1F5F9;
}

.appointment-show__section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.appointment-show__section-title h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #0F172A;
}

.appointment-show__section-icon {
  color: #0EA5E9;
  font-size: 20px;
}

.appointment-show__id-badge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 4px;
  background: #EFF6FF;
  color: #0284C7;
  font-size: 12px;
  font-weight: 600;
}

.appointment-show__section-meta {
  font-size: 13px;
  font-weight: 500;
  color: #64748B;
}

.appointment-show__link {
  border: 0;
  background: transparent;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  color: #0EA5E9;
  cursor: pointer;
  font-family: inherit;
}

.appointment-show__link:hover {
  text-decoration: underline;
}

.appointment-show__tiles {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
}

.appointment-show__tile {
  border: 1px solid #F1F5F9;
  border-radius: 8px;
  background: #F8FAFC;
  padding: 14px;
  min-width: 0;
}

.appointment-show__tile-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
}

.appointment-show__tile-value {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
  min-width: 0;
}

.appointment-show__tile-value .anticon {
  color: #0EA5E9;
  font-size: 18px;
  flex-shrink: 0;
}

.appointment-show__tile-value span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.appointment-show__tile-sub {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748B;
}

.appointment-show__tile-sub.is-accent {
  color: #0EA5E9;
  font-weight: 500;
}

.appointment-show__fields {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
}

.appointment-show__field-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
}

.appointment-show__field-value {
  margin-top: 4px;
  font-size: 15px;
  font-weight: 600;
  color: #0F172A;
}

.appointment-show__field-value.is-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  color: #0EA5E9;
  font-variant-numeric: tabular-nums;
}

.appointment-show__note {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #F1F5F9;
}

.appointment-show__note-label {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
}

.appointment-show__note-text {
  margin-top: 6px;
  font-size: 14px;
  color: #0F172A;
  line-height: 1.45;
  white-space: pre-wrap;
}

.appointment-show__btn--sm {
  height: 32px;
  padding: 0 14px;
  font-size: 12px;
}

.appointment-show__packages {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.appointment-show__package {
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #F8FAFC;
  padding: 16px;
  transition: border-color 0.12s ease;
}

.appointment-show__package:hover {
  border-color: #CBD5E1;
}

.appointment-show__package-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.appointment-show__package-main {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.appointment-show__package-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #E0F2FE;
  color: #0EA5E9;
  flex-shrink: 0;
}

.appointment-show__package-name {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #0F172A;
}

.appointment-show__package-chip {
  display: inline-flex;
  align-items: center;
  height: 20px;
  margin-inline-start: 8px;
  padding: 0 8px;
  border-radius: 9999px;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 11px;
  font-weight: 600;
}

.appointment-show__package-metrics {
  display: flex;
  align-items: center;
  gap: 24px;
  padding-inline-end: 24px;
  border-inline-end: 1px solid #E2E8F0;
  text-align: end;
}

.appointment-show__metric-label {
  display: block;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
}

.appointment-show__metric-value {
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
}

.appointment-show__metric-value.is-remaining {
  color: #059669;
}

.appointment-show__metric-unit {
  font-size: 12px;
  font-weight: 500;
  color: #64748B;
}

.appointment-show__package-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  padding: 0 10px;
  border-radius: 9999px;
  border: 1px solid #FED7AA;
  background: #FFFBEB;
  color: #D97706;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.appointment-show__package-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: currentColor;
}

.appointment-show__package-progress {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #F1F5F9;
}

.appointment-show__progress-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
  font-size: 12px;
  color: #64748B;
}

.appointment-show__progress-meta strong {
  font-weight: 500;
  color: #0F172A;
}

.appointment-show__progress-track {
  height: 8px;
  width: 100%;
  overflow: hidden;
  border-radius: 9999px;
  background: #E2E8F0;
}

.appointment-show__progress-fill {
  height: 100%;
  border-radius: 9999px;
  background: #0EA5E9;
}

.appointment-show__empty {
  padding: 20px;
  text-align: center;
  font-size: 13px;
  color: #64748B;
  border: 1px dashed #E2E8F0;
  border-radius: 8px;
  background: #F8FAFC;
}

@media (max-width: 1100px) {
  .appointment-show__tiles,
  .appointment-show__fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .appointment-show__header,
  .appointment-show__body {
    padding: 16px;
  }

  .appointment-show__tiles,
  .appointment-show__fields {
    grid-template-columns: 1fr;
  }

  .appointment-show__package-metrics {
    border-inline-end: 0;
    padding-inline-end: 0;
  }
}

/* Drawers — keep existing sizing */
.transaction-drawer,
.settlement-drawer,
.package-usage-drawer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.transaction-drawer .ant-drawer-content-wrapper {
  width: 1100px !important;
  height: 642px !important;
}

.settlement-drawer .ant-drawer-content-wrapper {
  width: 1100px !important;
  height: 242px !important;
}

.package-usage-drawer .ant-drawer-content-wrapper {
  width: 1100px !important;
  height: 342px !important;
}


/* —— Appointment — Add to journey drawer (Stitch / Clinical Precision) —— */
.appointment-journey-drawer.ant-drawer .ant-drawer-content-wrapper {
  width: 640px !important;
  max-width: calc(100vw - 24px);
}

.appointment-journey-drawer .ant-drawer-header {
  display: none;
}

.appointment-journey-drawer .ant-drawer-body {
  padding: 0 !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
}

.appointment-journey-drawer__shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.appointment-journey-drawer__header {
  flex-shrink: 0;
  padding: 24px;
  border-bottom: 1px solid #E2E8F0;
  background: #ffffff;
}

.appointment-journey-drawer__title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.appointment-journey-drawer__title-block {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  min-width: 0;
}

.appointment-journey-drawer__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #0F172A;
  line-height: 1.25;
}

.appointment-journey-drawer__badge {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 10px;
  border-radius: 9999px;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.appointment-journey-drawer__subtitle {
  margin: 6px 0 0;
  padding-inline-start: 44px;
  font-size: 12px;
  line-height: 16px;
  color: #64748B;
}

.appointment-journey-drawer__subtitle-em {
  font-weight: 500;
  color: #0F172A;
}

.appointment-journey-drawer__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #64748B;
  cursor: pointer;
  flex-shrink: 0;
}

.appointment-journey-drawer__icon-btn--bordered {
  border: 1px solid #E2E8F0;
  color: #475569;
}

.appointment-journey-drawer__icon-btn:hover {
  background: #F1F5F9;
  color: #0F172A;
}

[dir='rtl'] .appointment-journey-drawer__title-block > .appointment-journey-drawer__icon-btn .anticon {
  transform: scaleX(-1);
}

.appointment-journey-drawer__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 24px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.appointment-journey-drawer__existing-link {
  align-self: flex-start;
  border: 0;
  background: transparent;
  color: #0284C7;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  padding: 0;
}

.appointment-journey-drawer__existing-link:hover {
  text-decoration: underline;
}

.appointment-journey-drawer__list-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.appointment-journey-drawer__section-label {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748B;
}

.appointment-journey-drawer__selected-count {
  font-size: 12px;
  font-weight: 600;
  color: #94A3B8;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.appointment-journey-drawer__selected-count.is-active {
  color: #0284C7;
}

.appointment-journey-drawer__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.appointment-journey-drawer__card {
  box-sizing: border-box;
  width: 100%;
  text-align: start;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  cursor: pointer;
  font-family: inherit;
  transition: border-color 0.12s ease, background 0.12s ease;
}

.appointment-journey-drawer__card:hover {
  border-color: #CBD5E1;
}

.appointment-journey-drawer__card.is-selected {
  border: 2px solid #0EA5E9;
  background: #F0F9FF;
  box-shadow: 0 0 0 1px rgba(14, 165, 233, 0.2);
  padding: 15px;
}

.appointment-journey-drawer__card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.appointment-journey-drawer__card-main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex-wrap: wrap;
}

.appointment-journey-drawer__radio {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 9999px;
  border: 2px solid #CBD5E1;
  background: #ffffff;
  color: #ffffff;
  font-size: 11px;
  flex-shrink: 0;
}

.appointment-journey-drawer__radio.is-on {
  border-color: #0EA5E9;
  background: #0EA5E9;
}

.appointment-journey-drawer__card-name {
  font-size: 14px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.35;
  letter-spacing: -0.01em;
}

.appointment-journey-drawer__clinic-chip {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 4px;
  background: #F1F5F9;
  color: #334155;
  font-size: 12px;
  font-weight: 500;
}

.appointment-journey-drawer__card-clinic {
  margin: 8px 0 0;
  padding-inline-start: 30px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.45;
  color: #475569;
}

.appointment-journey-drawer__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 20px;
  padding: 0 10px;
  border-radius: 9999px;
  border: 1px solid transparent;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.appointment-journey-drawer__status.is-progress {
  background: #E0F2FE;
  border-color: #BAE6FD;
  color: #0284C7;
}

.appointment-journey-drawer__status.is-progress .appointment-journey-drawer__status-dot {
  background: #0EA5E9;
}

.appointment-journey-drawer__status.is-open {
  background: #FFFBEB;
  border-color: #FDE68A;
  color: #D97706;
}

.appointment-journey-drawer__status.is-open .appointment-journey-drawer__status-dot {
  background: #D97706;
}

.appointment-journey-drawer__status.is-muted {
  background: rgba(226, 232, 240, 0.8);
  color: #64748B;
}

.appointment-journey-drawer__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #94A3B8;
}

.appointment-journey-drawer__card-foot {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 12px;
  margin-top: 10px;
  padding-top: 10px;
  padding-inline-start: 30px;
  border-top: 1px solid #F1F5F9;
  font-size: 12px;
  color: #64748B;
  font-variant-numeric: tabular-nums;
}

.appointment-journey-drawer__card.is-selected .appointment-journey-drawer__card-foot {
  border-top-color: rgba(186, 230, 253, 0.8);
}

.appointment-journey-drawer__meta {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.appointment-journey-drawer__meta .anticon {
  color: #94A3B8;
  font-size: 14px;
}

.appointment-journey-drawer__meta-sep {
  color: #94A3B8;
}

.appointment-journey-drawer__create-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  border: 0;
  background: transparent;
  color: #0284C7;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  padding: 0;
}

.appointment-journey-drawer__create-link:hover:not(:disabled) {
  text-decoration: underline;
}

.appointment-journey-drawer__create-link:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.appointment-journey-drawer__create-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #BAE6FD;
  background: #ffffff;
  color: #0284C7;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.appointment-journey-drawer__create-btn:hover:not(:disabled) {
  background: #F0F9FF;
}

.appointment-journey-drawer__create-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.appointment-journey-drawer__note {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px;
  border-radius: 12px;
  border: 1px solid #BAE6FD;
  background: #F0F9FF;
  color: #475569;
  font-size: 12px;
  line-height: 1.5;
}

.appointment-journey-drawer__note > .anticon {
  margin-top: 2px;
  color: #0284C7;
  font-size: 18px;
  flex-shrink: 0;
}

.appointment-journey-drawer__note p {
  margin: 0;
}

.appointment-journey-drawer__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 120px;
  padding: 24px;
  text-align: center;
  color: #94A3B8;
  font-size: 13px;
  font-weight: 500;
}

.appointment-journey-drawer__empty p {
  margin: 0;
}

.appointment-journey-drawer__footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #E2E8F0;
  background: #ffffff;
}

.appointment-journey-drawer__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 20px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, color 0.12s ease;
}

.appointment-journey-drawer__btn--ghost {
  border: 0;
  background: transparent;
  color: #475569;
}

.appointment-journey-drawer__btn--ghost:hover {
  background: #F1F5F9;
  color: #0F172A;
}

.appointment-journey-drawer__btn--primary {
  border: 0;
  background: #0EA5E9;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.appointment-journey-drawer__btn--primary:hover:not(:disabled) {
  background: #0284C7;
}

.appointment-journey-drawer__btn--primary:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShowAppointment/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;;IAEE,gDAAgD;EAClD;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA,mCAAmC;AACnC;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;;AAGA,4EAA4E;AAC5E;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".appointment-show {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-height: 100%;\n}\n\n.appointment-show__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 20px 32px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.appointment-show__header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  min-width: 0;\n}\n\n.appointment-show__back {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #64748B;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.12s ease, color 0.12s ease;\n}\n\n.appointment-show__back:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n[dir='rtl'] .appointment-show__back .anticon {\n  transform: scaleX(-1);\n}\n\n.appointment-show__title-block {\n  min-width: 0;\n}\n\n.appointment-show__title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.appointment-show__title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.015em;\n  line-height: 1.2;\n  color: #0F172A;\n}\n\n.appointment-show__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 500;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.appointment-show__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: currentColor;\n  flex-shrink: 0;\n}\n\n.appointment-show__status.is-waiting {\n  background: #FFFBEB;\n  color: #B45309;\n  border-color: #FED7AA;\n}\n\n.appointment-show__status.is-confirmed {\n  background: #ECFDF5;\n  color: #059669;\n  border-color: #A7F3D0;\n}\n\n.appointment-show__status.is-invisit {\n  background: #EFF6FF;\n  color: #0284C7;\n  border-color: #BFDBFE;\n}\n\n.appointment-show__status.is-finished {\n  background: #F1F5F9;\n  color: #475569;\n  border-color: #E2E8F0;\n}\n\n.appointment-show__status.is-cancelled {\n  background: #FEF2F2;\n  color: #DC2626;\n  border-color: #FECACA;\n}\n\n.appointment-show__status.is-pending,\n.appointment-show__status.is-unreached,\n.appointment-show__status.is-afterwork,\n.appointment-show__status.is-postponed {\n  background: #F8FAFC;\n  color: #64748B;\n  border-color: #E2E8F0;\n}\n\n.appointment-show__actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.appointment-show__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.appointment-show__btn--secondary {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #0F172A;\n}\n\n.appointment-show__btn--secondary:hover {\n  background: #F8FAFC;\n}\n\n.appointment-show__btn--secondary .anticon {\n  color: #64748B;\n  font-size: 14px;\n}\n\n.appointment-show__btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n}\n\n.appointment-show__btn--primary:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.appointment-show__btn--finish {\n  border: 1px solid #10B981;\n  background: #ECFDF5;\n  color: #059669;\n}\n\n.appointment-show__btn--finish:hover {\n  background: #D1FAE5;\n}\n\n.appointment-show__btn--finish .anticon {\n  font-size: 16px;\n}\n\n.appointment-show__body {\n  flex: 1;\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  overflow: auto;\n}\n\n.appointment-show__section {\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: #ffffff;\n  padding: 24px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n}\n\n.appointment-show__section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding-bottom: 12px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.appointment-show__section-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.appointment-show__section-title h2 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0F172A;\n}\n\n.appointment-show__section-icon {\n  color: #0EA5E9;\n  font-size: 20px;\n}\n\n.appointment-show__id-badge {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 4px;\n  background: #EFF6FF;\n  color: #0284C7;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.appointment-show__section-meta {\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748B;\n}\n\n.appointment-show__link {\n  border: 0;\n  background: transparent;\n  padding: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0EA5E9;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.appointment-show__link:hover {\n  text-decoration: underline;\n}\n\n.appointment-show__tiles {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 24px;\n}\n\n.appointment-show__tile {\n  border: 1px solid #F1F5F9;\n  border-radius: 8px;\n  background: #F8FAFC;\n  padding: 14px;\n  min-width: 0;\n}\n\n.appointment-show__tile-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.appointment-show__tile-value {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n  min-width: 0;\n}\n\n.appointment-show__tile-value .anticon {\n  color: #0EA5E9;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.appointment-show__tile-value span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.appointment-show__tile-sub {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.appointment-show__tile-sub.is-accent {\n  color: #0EA5E9;\n  font-weight: 500;\n}\n\n.appointment-show__fields {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 24px;\n}\n\n.appointment-show__field-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.appointment-show__field-value {\n  margin-top: 4px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.appointment-show__field-value.is-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  color: #0EA5E9;\n  font-variant-numeric: tabular-nums;\n}\n\n.appointment-show__note {\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid #F1F5F9;\n}\n\n.appointment-show__note-label {\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.appointment-show__note-text {\n  margin-top: 6px;\n  font-size: 14px;\n  color: #0F172A;\n  line-height: 1.45;\n  white-space: pre-wrap;\n}\n\n.appointment-show__btn--sm {\n  height: 32px;\n  padding: 0 14px;\n  font-size: 12px;\n}\n\n.appointment-show__packages {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.appointment-show__package {\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #F8FAFC;\n  padding: 16px;\n  transition: border-color 0.12s ease;\n}\n\n.appointment-show__package:hover {\n  border-color: #CBD5E1;\n}\n\n.appointment-show__package-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.appointment-show__package-main {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.appointment-show__package-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: #E0F2FE;\n  color: #0EA5E9;\n  flex-shrink: 0;\n}\n\n.appointment-show__package-name {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.appointment-show__package-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  margin-inline-start: 8px;\n  padding: 0 8px;\n  border-radius: 9999px;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.appointment-show__package-metrics {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  padding-inline-end: 24px;\n  border-inline-end: 1px solid #E2E8F0;\n  text-align: end;\n}\n\n.appointment-show__metric-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.appointment-show__metric-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.appointment-show__metric-value.is-remaining {\n  color: #059669;\n}\n\n.appointment-show__metric-unit {\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748B;\n}\n\n.appointment-show__package-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 24px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  border: 1px solid #FED7AA;\n  background: #FFFBEB;\n  color: #D97706;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.appointment-show__package-status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: currentColor;\n}\n\n.appointment-show__package-progress {\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid #F1F5F9;\n}\n\n.appointment-show__progress-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 6px;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.appointment-show__progress-meta strong {\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.appointment-show__progress-track {\n  height: 8px;\n  width: 100%;\n  overflow: hidden;\n  border-radius: 9999px;\n  background: #E2E8F0;\n}\n\n.appointment-show__progress-fill {\n  height: 100%;\n  border-radius: 9999px;\n  background: #0EA5E9;\n}\n\n.appointment-show__empty {\n  padding: 20px;\n  text-align: center;\n  font-size: 13px;\n  color: #64748B;\n  border: 1px dashed #E2E8F0;\n  border-radius: 8px;\n  background: #F8FAFC;\n}\n\n@media (max-width: 1100px) {\n  .appointment-show__tiles,\n  .appointment-show__fields {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 720px) {\n  .appointment-show__header,\n  .appointment-show__body {\n    padding: 16px;\n  }\n\n  .appointment-show__tiles,\n  .appointment-show__fields {\n    grid-template-columns: 1fr;\n  }\n\n  .appointment-show__package-metrics {\n    border-inline-end: 0;\n    padding-inline-end: 0;\n  }\n}\n\n/* Drawers — keep existing sizing */\n.transaction-drawer,\n.settlement-drawer,\n.package-usage-drawer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.transaction-drawer .ant-drawer-content-wrapper {\n  width: 1100px !important;\n  height: 642px !important;\n}\n\n.settlement-drawer .ant-drawer-content-wrapper {\n  width: 1100px !important;\n  height: 242px !important;\n}\n\n.package-usage-drawer .ant-drawer-content-wrapper {\n  width: 1100px !important;\n  height: 342px !important;\n}\n\n\n/* —— Appointment — Add to journey drawer (Stitch / Clinical Precision) —— */\n.appointment-journey-drawer.ant-drawer .ant-drawer-content-wrapper {\n  width: 640px !important;\n  max-width: calc(100vw - 24px);\n}\n\n.appointment-journey-drawer .ant-drawer-header {\n  display: none;\n}\n\n.appointment-journey-drawer .ant-drawer-body {\n  padding: 0 !important;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.appointment-journey-drawer__shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.appointment-journey-drawer__header {\n  flex-shrink: 0;\n  padding: 24px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.appointment-journey-drawer__title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.appointment-journey-drawer__title-block {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.appointment-journey-drawer__title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: #0F172A;\n  line-height: 1.25;\n}\n\n.appointment-journey-drawer__badge {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.appointment-journey-drawer__subtitle {\n  margin: 6px 0 0;\n  padding-inline-start: 44px;\n  font-size: 12px;\n  line-height: 16px;\n  color: #64748B;\n}\n\n.appointment-journey-drawer__subtitle-em {\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.appointment-journey-drawer__icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748B;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.appointment-journey-drawer__icon-btn--bordered {\n  border: 1px solid #E2E8F0;\n  color: #475569;\n}\n\n.appointment-journey-drawer__icon-btn:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n[dir='rtl'] .appointment-journey-drawer__title-block > .appointment-journey-drawer__icon-btn .anticon {\n  transform: scaleX(-1);\n}\n\n.appointment-journey-drawer__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 24px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.appointment-journey-drawer__existing-link {\n  align-self: flex-start;\n  border: 0;\n  background: transparent;\n  color: #0284C7;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  padding: 0;\n}\n\n.appointment-journey-drawer__existing-link:hover {\n  text-decoration: underline;\n}\n\n.appointment-journey-drawer__list-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.appointment-journey-drawer__section-label {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.appointment-journey-drawer__selected-count {\n  font-size: 12px;\n  font-weight: 600;\n  color: #94A3B8;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.appointment-journey-drawer__selected-count.is-active {\n  color: #0284C7;\n}\n\n.appointment-journey-drawer__list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.appointment-journey-drawer__card {\n  box-sizing: border-box;\n  width: 100%;\n  text-align: start;\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  cursor: pointer;\n  font-family: inherit;\n  transition: border-color 0.12s ease, background 0.12s ease;\n}\n\n.appointment-journey-drawer__card:hover {\n  border-color: #CBD5E1;\n}\n\n.appointment-journey-drawer__card.is-selected {\n  border: 2px solid #0EA5E9;\n  background: #F0F9FF;\n  box-shadow: 0 0 0 1px rgba(14, 165, 233, 0.2);\n  padding: 15px;\n}\n\n.appointment-journey-drawer__card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.appointment-journey-drawer__card-main {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  flex-wrap: wrap;\n}\n\n.appointment-journey-drawer__radio {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 9999px;\n  border: 2px solid #CBD5E1;\n  background: #ffffff;\n  color: #ffffff;\n  font-size: 11px;\n  flex-shrink: 0;\n}\n\n.appointment-journey-drawer__radio.is-on {\n  border-color: #0EA5E9;\n  background: #0EA5E9;\n}\n\n.appointment-journey-drawer__card-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.35;\n  letter-spacing: -0.01em;\n}\n\n.appointment-journey-drawer__clinic-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 4px;\n  background: #F1F5F9;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.appointment-journey-drawer__card-clinic {\n  margin: 8px 0 0;\n  padding-inline-start: 30px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.45;\n  color: #475569;\n}\n\n.appointment-journey-drawer__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 20px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  border: 1px solid transparent;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.appointment-journey-drawer__status.is-progress {\n  background: #E0F2FE;\n  border-color: #BAE6FD;\n  color: #0284C7;\n}\n\n.appointment-journey-drawer__status.is-progress .appointment-journey-drawer__status-dot {\n  background: #0EA5E9;\n}\n\n.appointment-journey-drawer__status.is-open {\n  background: #FFFBEB;\n  border-color: #FDE68A;\n  color: #D97706;\n}\n\n.appointment-journey-drawer__status.is-open .appointment-journey-drawer__status-dot {\n  background: #D97706;\n}\n\n.appointment-journey-drawer__status.is-muted {\n  background: rgba(226, 232, 240, 0.8);\n  color: #64748B;\n}\n\n.appointment-journey-drawer__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: #94A3B8;\n}\n\n.appointment-journey-drawer__card-foot {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px 12px;\n  margin-top: 10px;\n  padding-top: 10px;\n  padding-inline-start: 30px;\n  border-top: 1px solid #F1F5F9;\n  font-size: 12px;\n  color: #64748B;\n  font-variant-numeric: tabular-nums;\n}\n\n.appointment-journey-drawer__card.is-selected .appointment-journey-drawer__card-foot {\n  border-top-color: rgba(186, 230, 253, 0.8);\n}\n\n.appointment-journey-drawer__meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.appointment-journey-drawer__meta .anticon {\n  color: #94A3B8;\n  font-size: 14px;\n}\n\n.appointment-journey-drawer__meta-sep {\n  color: #94A3B8;\n}\n\n.appointment-journey-drawer__create-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  align-self: flex-start;\n  border: 0;\n  background: transparent;\n  color: #0284C7;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  padding: 0;\n}\n\n.appointment-journey-drawer__create-link:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n.appointment-journey-drawer__create-link:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.appointment-journey-drawer__create-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 8px;\n  border: 1px solid #BAE6FD;\n  background: #ffffff;\n  color: #0284C7;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.appointment-journey-drawer__create-btn:hover:not(:disabled) {\n  background: #F0F9FF;\n}\n\n.appointment-journey-drawer__create-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.appointment-journey-drawer__note {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 14px;\n  border-radius: 12px;\n  border: 1px solid #BAE6FD;\n  background: #F0F9FF;\n  color: #475569;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.appointment-journey-drawer__note > .anticon {\n  margin-top: 2px;\n  color: #0284C7;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.appointment-journey-drawer__note p {\n  margin: 0;\n}\n\n.appointment-journey-drawer__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  min-height: 120px;\n  padding: 24px;\n  text-align: center;\n  color: #94A3B8;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.appointment-journey-drawer__empty p {\n  margin: 0;\n}\n\n.appointment-journey-drawer__footer {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.appointment-journey-drawer__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 20px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, color 0.12s ease;\n}\n\n.appointment-journey-drawer__btn--ghost {\n  border: 0;\n  background: transparent;\n  color: #475569;\n}\n\n.appointment-journey-drawer__btn--ghost:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.appointment-journey-drawer__btn--primary {\n  border: 0;\n  background: #0EA5E9;\n  color: #ffffff;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.appointment-journey-drawer__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n}\n\n.appointment-journey-drawer__btn--primary:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
